import React from 'react';
import { PageBanner } from './ArtistPageBanner';
import { useGetPopularArtists } from '@services/artist/hooks/useGetPopularArtists';
import s from './artistsGrid.module.scss';
interface PageProps {
  children: React.ReactNode;
  showBanners?: boolean;
  limit?: number;
  itemsLength?: number;
  skipFirstBanner?: boolean;
}
const PageMemo: React.FC<PageProps> = ({
  showBanners,
  children,
  skipFirstBanner
}) => {
  const {
    data,
    status
  } = useGetPopularArtists({});
  if (showBanners && status !== 'success') return null;
  return <div className={s.artistsGrid__page} data-sentry-component="PageMemo" data-sentry-source-file="ArtistPage.tsx">
            {showBanners && !!data?.length && !skipFirstBanner && <PageBanner data={data} />}
            {children}
        </div>;
};
export const Page = React.memo(PageMemo);